export default {
  "song": {
    "commentCount": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx;return _plural([_normalize(["Нет Комментарий"]), _normalize(["1 Комментарий"]), _normalize([_interpolate(_named("count")), " Комментарий"])])}
  },
  "home": {
    "listen": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Слушай замечательную музыку"])}
  },
  "register": {
    "TOS": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "accept": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
  }
}